import { render, staticRenderFns } from "./ArticleDiscuss.vue?vue&type=template&id=43b2c40e&scoped=true"
import script from "./ArticleDiscuss.vue?vue&type=script&lang=js"
export * from "./ArticleDiscuss.vue?vue&type=script&lang=js"
import style0 from "./ArticleDiscuss.vue?vue&type=style&index=0&id=43b2c40e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b2c40e",
  null
  
)

export default component.exports